import { IconGlyph } from '../primitives/index.js';

type SettingsRowProps = { body?: string; href: string; icon: string; title: string };

function SettingsRow(props: SettingsRowProps & { className: string }) {
  return <a className={props.className} href={props.href}><span aria-hidden="true"><IconGlyph value={props.icon} /></span><div><strong>{props.title}</strong>{props.body ? <p>{props.body}</p> : null}</div><b aria-hidden="true"><IconGlyph value="›" /></b></a>;
}

export function SettingsMenuRow(props: SettingsRowProps) {
  return <SettingsRow {...props} className="mira-settings-row" />;
}

export function SettingsPrivacyRow(props: SettingsRowProps & { body: string }) {
  return <SettingsRow {...props} className="mira-settings-privacy-row" />;
}
